<mat-stepper [linear]="!catStep.completed" labelPosition="bottom" #configStepper>
    <!-- 1st step starts -->
    <mat-step label="Category" [completed]="catStep.completed" [editable]="canStepAway()" #catStep>
        <h2>Categories</h2>
        <p class="lead">Categories allow you to group similar rule settings together.</p>
        <div class="row mt-md-4 mx-md-2">
            <div *ngIf="ruleSets?.length" class="col-sm-12 col-md-6 col-lg-5" [ngClass]="!isSuperUser ? 'col-md-10 col-lg-10': null">
                <fieldset class="border">
                    <legend>Existing categories</legend>

                    <table class="table table-borderless mb-0">
                        <thead>
                            <tr>
                                <th scope="col" class="pr-0">Category</th>
                                <th scope="col" class="pr-0">Column</th>
                                <th scope="col" class="px-0">Importance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ruleSet of ruleSets">
                                <td>{{ruleSet.name}}</td>
                                <td>{{ruleSet.organisation_column_name}}</td>
                                <td class="px-md-0">{{ruleSet.default_importance}}</td>
                                <td class="px-md-0"><button *ngIf="ruleSet.name"
                                        class="basic-button-base button-dark mb-0"
                                        (click)="stepToSettings(ruleSet)">{{isSuperUser ? 'edit' : 'view'}}</button></td>
                            </tr>

                        </tbody>
                    </table>
                </fieldset>
            </div>
            <div *ngIf="isSuperUser" class="col-sm-12 col-md-6 col-lg-7">
                <fieldset class="border row align-items-end">
                    <legend>Create a new category</legend>

                    <div class="col-md-4">
                        <label for="ruleSetName">Category Name:</label>
                        <input type="text" id="ruleSetName" class="form-control" [(ngModel)]="newRuleSetName"
                            maxlength="65" required>
                    </div>
                    <div class="col-md-4">
                        <label for="ruleImportance">Importance</label>
                        <select [(ngModel)]="newRuleSetImportance" id="ruleImportance" class="custom-select rounded-0">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label for="customColumns">User Column:</label>
                        <select (ngModelChange)="addCustomUserColumn($event)"
                            [(ngModel)]="selectedUserColumnIDForNewRuleSetSubscription" class="custom-select rounded-0"
                            id="customColumns">
                            <option *ngFor="let userOrganisationCustomColumn of userOrganisationCustomColumns"
                                [value]="userOrganisationCustomColumn.id">
                                {{userOrganisationCustomColumn.name}}
                            </option>
                            <hr />
                            <option value="newColumn" title="auto-generated">Add a new column</option>
                        </select>
                    </div>
                    <div class="col-sm d-flex flex-row-reverse justify-content-between">
                        <button class="basic-button-base button-dark mt-2"
                            (click)="createNewRulesetSubscription()">Create <i
                                class="fal fa-arrow-alt-circle-right"></i></button>
                        <div *ngIf="userConfigErrors.newRuleSetError" class="">
                            <mat-error class="small">{{userConfigErrors.newRuleSetError}}</mat-error>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </mat-step>
    <!-- 1st step ends -->

    <!-- 2nd step starts -->
    <mat-step #backgroundStep *ngIf="ruleSets" label="Background"> 
        <div *ngIf="!isSuperUser && selectedRuleSetIndex && !ruleSets[selectedRuleSetIndex]?.can_edit" class="no-access"><span class="">You cannot edit this category. Please ask your superuser for edit access.</span></div>      
        <div *ngIf="ruleSets[selectedRuleSetIndex]" class="col-md-12">
            <h2>Optional Background Information for AI suggestions</h2>
            <p class="small-margin-top">Complete the following optional section to create AI-generated suggestions. By
                entering data below you agree to the <a href="#termsForChatGPTFeatures" data-toggle="modal"
                    data-target="#termsForChatGPTFeatures">additional terms.</a></p>
            <openai-terms-modal></openai-terms-modal>
            <p>Describe the products and services that you provide and the challenges that you help businesses overcome:
            </p>
            <textarea [attr.disabled]="this.isLoading.loadingUpdateRuleSet ? 'disabled': null"
                [(ngModel)]="ruleSets[selectedRuleSetIndex].about_us" maxlength="1024" style="min-height: 10em"
                type="text" placeholder="- Acme is a leading manufacturer of green packaging solutions.
- Acme empowers consumer goods brands to achieve their green goals without slowing down."
                class="form-control text-custom-column-textarea">
            </textarea>
            <button class="basic-button-base button-dark xsmall-margin-top" (click)="updateRuleSetAboutUs()"
                [attr.disabled]="this.isLoading.loadingUpdateRuleSet ? 'disabled': null"><ng-container
                    *ngIf="this.isLoading.loadingUpdateRuleSet"><i class="fal fa-spinner fa-spin"></i></ng-container>
                Submit</button>
            <button class="basic-button-base button-dark mt-1 ml-2" matTooltip="Skip this step"
                (click)="skipBackgroundStep()">Skip</button>
        </div>
    </mat-step>
    <!-- 2nd step ends -->

    <!-- 3rd step starts -->
    <mat-step #settingsStep label="Settings" (interacted)="refreshTrackingTable()">
        <div *ngIf="!isSuperUser && selectedRuleSetIndex && !ruleSets[selectedRuleSetIndex]?.can_edit" class="no-access"><span class="">You cannot edit this category. Please ask your superuser for edit access.</span></div>
        <div class="column" *ngIf="ruleSets">
            <div class="col-md-12 small-margin-bottom">
                <h2>Notification Settings</h2>
                <p class="lead">Configure your notification rules for each category.
                </p>
            </div>
            <div class="col-md-4 mb-2">
                Showing rules in selected category
                <select [(ngModel)]="selectedRuleSetIndex" (ngModelChange)="refreshTrackingTable()"
                    class="custom-select">
                    <option *ngFor="let ruleSet of ruleSets; let i = index; trackBy: trackByIndex" [value]="i" selected>
                        {{ ruleSet.name }}
                    </option>
                </select>
            </div>
            <div class="col-md-6 my-2" *ngIf="isEditingRuleSet">
                <input type="text" class="pl-1" placeholder="new category name"
                    [(ngModel)]="ruleSets[selectedRuleSetIndex].name" />
                <input type="number" min="1" max="5" [(ngModel)]="ruleSets[selectedRuleSetIndex].default_importance"
                    class="mx-1 pl-1" style="width: 4rem;" />
                <button class="basic-button-base button-dark btn-sm edit-ruleset-btn"
                    (click)="updateRuleSetNameAndImportance()">OK</button>
                <div *ngIf="userConfigErrors.isUpdateValid === false" class="col-md-12">
                    <mat-error class="small">Please enter valid inputs to update.</mat-error>
                </div>
            </div>
            <div class="col-sm small-margin-bottom">
                <button class="basic-button-base button-dark" (click)="rulesetIndexToDelete = selectedRuleSetIndex;"
                    [disabled]="!ruleSets.length" data-toggle="modal" data-target="#confirmDeleteCategoryModal"><i
                        class="fal fa-trash"></i> Delete
                    This
                    Category</button>
                <button class="basic-button-base button-dark ml-2" (click)="toggleEditRuleSet()"><i
                        class="fal fa-edit"></i> Edit this
                    category</button>
            </div>

            <div class="col-sm-12 mb-2">
                <mat-accordion *ngIf="ruleSets && eventSourceTypes">
                    <i>Total number of notification rules in this category</i> -
                    <strong>{{ruleSets[selectedRuleSetIndex].rules?.length}}</strong>
                    <mat-expansion-panel [disabled]="isEditingRuleSet"
                        *ngFor="let eventSourceType of eventSourceTypes | keyvalue">
                        <mat-expansion-panel-header class="bg-light border" expandedHeight="3em">
                            <mat-panel-title class="d-flex justify-content-between">
                                <span class="font-weight-bold"><i
                                        [ngClass]="renderEventSourceIcon(eventSourceType.key)"></i>{{eventSourceType.key
                                    | removeTrailingEventType | camelCaseToProper}}</span>
                                <span class="badge badge-pill badge-count"
                                    *ngIf="ruleCount">{{ruleCount[eventSourceType.key]}}</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <event-souce-type-rules [ruleSet]="ruleSets[selectedRuleSetIndex]"
                            [eventSourceType]="eventSourceType.key" [parameterSchema]="eventSourceType.value"
                            (newRule)="newRule($event)" (deleteRule)="deleteRule($event)"></event-souce-type-rules>
                    </mat-expansion-panel>
                </mat-accordion>
                <button class="col-sm-2 basic-button-base button-dark my-2 float-right" matStepperNext>Next</button>
            </div>
        </div>
    </mat-step>
    <!-- 3rd step ends -->

    <!-- 4th (optional, superuser only) step starts -->
    <mat-step *ngIf="ruleSets && isSuperUser" label="Permissions">
        <h2>Permissions for category - <mark class="font-italic">{{ruleSets[selectedRuleSetIndex]?.name}}</mark></h2>
        <p class="lead">Assign users and teams that should receive notifications for this category to View Access.</p>
        <p class="lead">You may also assign any users or teams that should be able to edit this category.            
        </p>
        <div class="medium-margin-top d-flex flex-gap-1">
            @if (organisationViewUsers?.length || organisationViewTeams?.length) {
                <div class="zint-base-card flex-1">
                    <zint-permissions [permissionLabel]="'View Access:'" [allUsers]="organisationViewUsers" [allTeams]="organisationViewTeams" [existingUsers]="ruleSets[selectedRuleSetIndex]?.view_users" [existingTeams]="ruleSets[selectedRuleSetIndex]?.view_teams" (onPermissionChange)="handlePermissionsChange($event, 'view')"></zint-permissions>
                </div>
            }
            @if (organisationEditUsers?.length || organisationEditTeams?.length) {
                <div class="zint-base-card flex-1">
                    <zint-permissions [permissionLabel]="'Edit Access:'" [allUsers]="organisationEditUsers" [allTeams]="organisationEditTeams" [existingUsers]="ruleSets[selectedRuleSetIndex]?.edit_users" [existingTeams]="ruleSets[selectedRuleSetIndex]?.edit_teams" (onPermissionChange)="handlePermissionsChange($event, 'edit')"></zint-permissions>
                </div>
            }
        </div>
        <button class="col-sm-2 basic-button-base button-dark my-2 float-right" matStepperNext>Next</button>
    </mat-step>
    <!-- 4th (optional, superuser only) step starts -->


    <!-- 5th step starts -->
    <mat-step *ngIf="ruleSets" label="Track Companies">
        <div *ngIf="!isColumnEditableByUser" class="no-access"><span class="">You can only view this step. Please ask your superuser for edit access.</span></div>
        <h2>Track Companies</h2>
        <p class="lead">Set which user from your organisation should be assigned to which companies, for the current
            category of notification settings -
            <mark class="font-italic">{{ruleSets[selectedRuleSetIndex]?.name}}</mark>
        </p>

        <div class="mt-md-4">
            <mat-table [dataSource]="trackedCompanies" class="mat-elevation-z2 tracking-table">
                <!-- Table header with input fields and selects -->
                <ng-container matColumnDef="tableHeader">
                    <mat-header-cell *matHeaderCellDef [ngClass]="!isColumnEditableByUser ? 'bg-light': null">
                        <div class="col-md-2 p-top">
                            <span>Add new:</span>
                        </div>
                        <div class="col-md-4">
                            <select [disabled]="!isColumnEditableByUser" [(ngModel)]="selectedTeamMemberId" class="custom-select rounded-0" id="org-users">
                                <ng-container *ngFor="let user of viewUsers">
                                <option disabled >---Users---</option>
                                <option [value]="user.userId">{{user.userEmail}}</option> 
                                </ng-container> 
                                                              
                                <ng-container *ngFor="let team of viewTeamMembers">
                                    <option disabled>---{{team?.name}} Team---</option>
                                    <option *ngFor="let orgUser of team?.orgUsers" [value]="orgUser.userId">{{ orgUser.userEmail }}
                                    </option>
                                </ng-container>
                                
                            </select>
                        </div>

                        <div class="col-md-4">
                            <input type="text" class="form-control" [(ngModel)]="companyNameInput"
                                (ngModelChange)="searchForCompanyByName()" maxlength="160" id="navbarDropdownMenuLink"
                                placeholder="Search for a company" #searchMenuTrigger="matMenuTrigger"
                                [matMenuTriggerFor]="searchMenu" [disabled]="!isColumnEditableByUser"/>
                            <mat-menu #searchMenu="matMenu">

                                <div *ngFor="let shortlistedCompany of shortlistedCompaniesByName"
                                    class="d-flex align-items-baseline justify-content-between highlight">
                                    <p>{{ shortlistedCompany.company_name }} -
                                        <span class="font-italic font-weight-light">{{shortlistedCompany.revenue
                                            |
                                            companyDataPipe: "Revenue": null}}</span>
                                    </p>
                                    <div class="mx-2 d-flex">
                                        <button class="basic-button-base button-dark trackBtn" matTooltip="add company"
                                            matTooltipPosition="left" (click)="addToTrackingTable(shortlistedCompany)">
                                            <i class="fas fa-briefcase"></i>
                                        </button>
                                        <button class="basic-button-base button-dark trackBtn ml-1 btn-wait"
                                            matTooltip="entity group - Coming Soon :)" matTooltipPosition="right">
                                            <i class="fad fa-network-wired"></i>
                                        </button>
                                    </div>

                                </div>
                            </mat-menu>

                        </div>
                    </mat-header-cell>
                </ng-container>

                <!-- Define the columns to display -->
                <mat-header-row *matHeaderRowDef="['tableHeader']"></mat-header-row>

                <ng-container matColumnDef="userEmail">
                    <mat-header-cell *matHeaderCellDef>User</mat-header-cell>
                    <mat-cell *matCellDef="let tracking">{{ tracking.userEmail }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ukCompanyName">
                    <mat-header-cell *matHeaderCellDef>Company</mat-header-cell>
                    <mat-cell *matCellDef="let tracking">{{ tracking.ukCompanyName }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let tracking">
                        <div class="dropdown">
                            <button [disabled]="!isColumnEditableByUser" mat-icon-button [matMenuTriggerFor]="confirmDelete"
                                class="btn btn-outline-dark rounded-0">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                            <mat-menu #confirmDelete="matMenu" xPosition="after">
                                <span role="button" mat-menu-item (click)="deleteTrackedCompany(tracking.id)">
                                    Delete
                                </span>
                            </mat-menu>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- Define the columns to display -->
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>

            <!-- Add pagination control -->
            <mat-paginator [length]="totalRowsCount" [pageSize]="100"></mat-paginator>

            <div class="float-right">
                <button class="basic-button-base button-dark mx-2" (click)="configStepper.selectedIndex = 0">Config Home</button>
                <a href="/grow" class="basic-button-base button-dark">Zint Grow Home</a>
            </div>
        </div>
    </mat-step>
    <!-- 5th step ends -->
</mat-stepper>

<!-- stepper ends -->

<div class="modal fade" id="confirmDeleteCategoryModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="confirmDeleteCategoryModalLabel">Delete category?</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="rulesetIndexToDelete != null">
                <p>This can't be undone.</p>
                <button class="basic-button-base button-dark"
                    (click)="deleteRuleset(selectedRuleSetIndex)">Confirm</button>
            </div>
        </div>
    </div>
</div>